import { jsx as _jsx } from "react/jsx-runtime";
import { isVOBofType } from '@iotv/iotv-v3-types';
import { Button, Stack } from '@mui/material';
import { useContext } from 'react';
import { AppMainViewContext } from '../../../../../../ContextProviders/AppContextProvider';
import { DeviceControlDAO } from '../../../../../../data/DeviceControlDAO';
import { ActionIcons } from '../../../../../../Iconography';
export const Send = ({ devices, GenericControlReducerContext }) => {
    const [{ contextUser }] = useContext(AppMainViewContext);
    const { state: GenericControlState, dispatch: GenericControlDispatch } = useContext(GenericControlReducerContext);
    const { payloadRequestObject } = GenericControlState;
    const sendDownlinks = async ({ contextUser, devices, payload }) => {
        const res = { err: null, data: null };
        const typeFilter = (x) => isVOBofType('Device', x);
        const { err, data: sendData } = await DeviceControlDAO.device.control.command.send({
            desiredPayload: payload,
            devices: devices.filter(typeFilter),
            requestInitiator: contextUser,
        });
        if (err) {
            res.err = err;
        }
        if (sendData) {
            res.data = sendData;
        }
        return res;
    };
    const handleSend = async () => {
        if (contextUser) {
            const { err, data } = await sendDownlinks({ contextUser, devices, payload: payloadRequestObject });
            if (err) {
                console.error(`ERR: sendDownlinks handleSend `, err.message, { err, data });
            }
            if (data) {
                // TODO store sent payloads in limited array in state
                GenericControlDispatch({ type: 'ClearDownlinkObject', update: null });
            }
        }
    };
    const canSend = Object.keys(payloadRequestObject).length > 0;
    return (_jsx(Stack, { direction: 'row', children: _jsx(Button, { disabled: !canSend, variant: "contained", size: "large", color: "success", endIcon: _jsx(ActionIcons.Send, {}), onClick: () => handleSend(), children: devices.length > 1 ? `Send Group Command (${devices.length} devices)` : `Send Command` }) }));
};
